import Overlay from "./overlay";

export default class ModalMenu {
    constructor($el) {
        this.$el = $el;
        this.type = this.$el.dataset.modalMenu
        this.trigger = document.querySelector(`[data-modal-menu-trigger="${this.type}"]`);
        this.close = this.$el.querySelector('[data-modal-menu-close]');
        // this.hamburger = document.querySelector(`[data-hamburger="${this.type}"]`);
        this.animation = document.querySelector(`[data-modal-menu-animation="${this.type}"]`);
        this.icon = this.trigger.querySelector(`[data-modal-icon-trigger="${this.type}"]`);
        this.overlay = this.$el.dataset.modalOverlay;

        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);


        this.trigger.addEventListener('click', this.openModal);

        if(this.type === 'products'){
            this.trigger.addEventListener('mouseenter', this.openModal);
        }

        if(this.close) {
            this.close.addEventListener('click', this.closeModal);
        }
    }

    openModal(e) {
        e.preventDefault();

        const event = new CustomEvent('close-category-modal-menu');
        window.dispatchEvent(event);

        this.$el.classList.toggle('modal-menu--open');


        if(this.animation) {
            this.animation.classList.toggle('animation')
        }

        if(this.overlay) {
            var overlay = new Overlay();
            overlay.open();
        }

        if(this.icon) {
            this.icon.classList.toggle('animate');
        }

        // if( ! this.hamburger) {
        //     return;
        // }
        //
        // this.hamburger.classList.toggle('hamburger--open');
    }

    closeModal(e) {
        e.preventDefault();
        this.$el.classList.remove('modal-menu--open');

        if(this.animation) {
            this.animation.classList.remove('animation')
        }

        if(this.overlay) {
            var overlay = new Overlay();
            overlay.close();
        }

        if(this.icon) {
            this.icon.classList.remove('animate');
        }

        const event = new CustomEvent('remove-category-list');
        window.dispatchEvent(event);
    }
}